/*
 * Scroll parallax — a small vertical drift on full-bleed imagery, for depth.
 *
 * Enabled alongside scroll reveal (html.scroll-reveal-on is set by
 * snippets/theme-script.liquid), homepage only.
 *
 * Desktop fine-pointer only. Static on touch, narrow viewports and
 * prefers-reduced-motion. `.parallax-el` is added by this script only, so the
 * CSS offset never applies without JS.
 */
(function () {
  if (!document.documentElement.classList.contains('scroll-reveal-on')) return;

  var mq = window.matchMedia('(min-width: 900px) and (pointer: fine)');
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');

  var SELECTOR = '[data-parallax], .single-product-promo-bg-image';
  var MAX_SHIFT = 24; // px of drift between the two viewport edges

  var items = [];
  var ticking = false;
  var running = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < -vh * 0.3 || r.top > vh * 1.3) continue; // well offscreen
      var center = r.top + r.height / 2;
      var progress = (center - vh / 2) / (vh / 2 + r.height / 2);
      progress = progress < -1 ? -1 : progress > 1 ? 1 : progress;
      el.style.setProperty('--parallax-y', (progress * MAX_SHIFT).toFixed(1) + 'px');
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  function enable() {
    if (running) return;
    items = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!items.length) return;
    running = true;
    items.forEach(function (el) { el.classList.add('parallax-el'); });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function disable() {
    if (!running) return;
    running = false;
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    items.forEach(function (el) {
      el.classList.remove('parallax-el');
      el.style.removeProperty('--parallax-y');
    });
    items = [];
  }

  function evaluate() {
    if (mq.matches && !reduceMq.matches) enable();
    else disable();
  }

  evaluate();
  if (mq.addEventListener) {
    mq.addEventListener('change', evaluate);
    reduceMq.addEventListener('change', evaluate);
  }
})();
